/*Genera Menu (especial para SSC por guardar la selección del menu). entra como insumo el menú a pintar, tipo (1 o 2) es para el diseño, msj es un texto que muestra en el menu */

//*react- recursos
  import Nav from "react-bootstrap/Nav";
  import Navbar from "react-bootstrap/Navbar";

//*clases
  import Container from "react-bootstrap/Container";
  import "./menu.css";

//*store's
  import menuStore from "../../stores/menu.store";  

//*interfaces
  interface propsMenu {
    tipo: any;
    msj: any
  }

//*componente
  export default function GeneraMenu(props: propsMenu) {  //*api store
    //console.log('GeneraMenu: menu', props.menuxRolStore)
    //stores adicionales

    const { menuxRolStore, cambiaMenu } =  
      menuStore((state:any) =>( { 
        menuxRolStore: state.menuxRolStore,
        cambiaMenu: state.cambiaMenu,
      }));

    //*datos

    //*constantes y variables
    let menu = menuxRolStore;

    //*usestate
    //*useEffect
    //*funciones

    //*vista
    return (
      <>
        <div id="nav2">
          {/* Menú que se acomoda en cualquier parte*/}
          {props.tipo==1
            ?  <><br/>
                <Navbar expand="lg" className="bg-body-tertiary sticky-top " bg="light" >
                  <Container>                  
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                      <Nav className="me-auto" >
                        {menu.map((item: any) => (
                          <>
                            {item.activo == true
                              ? ( <Nav.Link onClick={()=>cambiaMenu({item})} className="active">{item.desc}</Nav.Link>   ) 
                              : ( <Nav.Link onClick={()=>cambiaMenu({item})} >{item.desc}</Nav.Link>  )
                            }
                          </>
                        ))}  
                      </Nav>
                    </Navbar.Collapse>
                  </Container>
                </Navbar>
               </>
            :  <></>
          }

          {/* Menu pegado arriba con una opción de mensaje a la izquierda, menu posterior de n elementos... */}
          {props.tipo==2
            ?  <>
                <div className="navbar">
                {menu.map((item: any) => (
                  <a key={item.id}>{item.desc}</a>
                ))}
                </div>
                <Navbar bg="light" expand="lg">
                  <Container fluid>
                    <Navbar.Brand href="#">{props.msj}</Navbar.Brand>
                    <Navbar.Toggle aria-controls="navbarScroll" />
                    <Navbar.Collapse id="navbarScroll">
                      <Nav
                        className="me-auto my-2 my-lg-0"
                        style={{ maxHeight: "100px" }}
                        navbarScroll
                      >
                        {menu.map((item: any) => (
                          <Nav.Link href="#action1">{item.desc} </Nav.Link>
                        ))}
                      </Nav>
                    </Navbar.Collapse>
                  </Container>
                </Navbar>
              </>
            : <></>
          }   
        </div>
      </>
    );
  }
